import React, { useEffect, useState } from "react";
import PageContainer from "../../layouts/PageContainer";
import { helpers } from '../../helper/helper';
import { useCallback } from "react";
import Loader from "../../layouts/Loader";
import { TextField, MenuItem } from '@material-ui/core';
import Posts from "./Posts";
import Shorts from "./Shorts";

const List = () => {
    const [pendingApprovalList, setPendingApprovalList] = useState();
    const [pendingApprovalPaginationList, setPendingApprovalPaginationList] = useState();
    const [filterText, setFilterText] = useState("post");
    const getDefaultLimit = (type) => (type === "reel" ? 12 : 10);

    const FetchRemainingApprovalList = useCallback(async (filterTe, search, page = 1, limit) => {
        const pageLimit = limit ?? getDefaultLimit(filterTe);
        const url = `users/admin/pending/approve/list/v1?type=${filterTe}&page=${page}&limit=${pageLimit}&search=${search}`;
        const result = await helpers.apiCall('GET', url);
        setPendingApprovalList(result.data);
        setPendingApprovalPaginationList(result.pagination.totalRecords);
    }, []);

    useEffect(() => {
        FetchRemainingApprovalList(filterText, "", 1, getDefaultLimit(filterText));
    }, [FetchRemainingApprovalList, filterText]);

    return (
        <PageContainer pageheading="Content Moderation LIST">
            {!pendingApprovalList ? <Loader /> :
                <>
                    <form>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="input-group serch-sec">

                                    <TextField
                                        select
                                        size="small"
                                        variant="outlined"
                                        value={filterText}
                                        onChange={(e) => {
                                            console.log('e.target.value', e.target.value)
                                            setFilterText(e.target.value)
                                        }}
                                        style={{ width: "220px" }}
                                    >
                                        {/* <MenuItem value="">Select Option</MenuItem> */}
                                        <MenuItem value="post">POST</MenuItem>
                                        <MenuItem value="reel">REEL</MenuItem>
                                    </TextField>

                                    &nbsp;

                                </div>
                            </div>
                        </div>
                    </form>
                    {filterText === "post" ? (
                        <Posts data={pendingApprovalList} count={pendingApprovalPaginationList} filterText={filterText} FetchRemainingApprovalList={FetchRemainingApprovalList}/>
                    ) : (
                        <Shorts data={pendingApprovalList} count={pendingApprovalPaginationList} filterText={filterText} FetchRemainingApprovalList={FetchRemainingApprovalList}/>
                    )}
                </>
            }
        </PageContainer>
    )
};

export default List;